// =====================================================================
// COSMETICA BEAUTY AWARDS 2027 — ENGLISH CONTENT
// All site copy lives here. To add English / Arabic:
// duplicate this file (content.en.js / content.ar.js) and register it
// in src/content/index.js — no component needs to be modified.
// =====================================================================

const content = {
  lang: "en",

  site: {
    name: "COSMETICA BEAUTY AWARDS",
    year: "2027",
    // Applications opening (Algiers time, UTC+1). The /apply switch is automatic.
    openingDate: "2026-11-10T00:00:00+01:00",
    applyUrl: "https://awards.cosmeticaafrica.com",
    applyDomain: "awards.cosmeticaafrica.com",
  },

  seo: {
    home: {
      title: "COSMETICA BEAUTY AWARDS 2027 — Celebrating beauty excellence",
      description:
        "The COSMETICA BEAUTY AWARDS celebrate the products and brands that stand out for their quality, creativity and innovation. 2027 edition: applications opening soon.",
    },
    categories: {
      title: "The 2027 Categories — COSMETICA BEAUTY AWARDS",
      description: "15 categories covering the main worlds of beauty, from Best Skincare Product to COSMETICA Beauty Product of the Year.",
    },
    finalists: {
      title: "Finalists — COSMETICA BEAUTY AWARDS 2027",
      description: "The finalists will be announced on 15 March 2027.",
    },
    winners: {
      title: "Winners — COSMETICA BEAUTY AWARDS 2027",
      description: "The winners will be unveiled in late April 2027 at the official ceremony.",
    },
    apply: {
      title: "Apply — COSMETICA BEAUTY AWARDS 2027",
      description: "Applications will open soon. Be notified of the opening on 10 November 2026.",
    },
    contact: {
      title: "Contact — COSMETICA BEAUTY AWARDS 2027",
      description: "Contact the COSMETICA BEAUTY AWARDS team.",
    },
  },

  a11y: {
    home: "COSMETICA BEAUTY AWARDS — Home",
    mainNav: "Main navigation",
    mobileNav: "Mobile navigation",
    language: "Language",
  },

  nav: {
    items: [
      { label: "The Awards", hash: "essence" },
      { label: "Categories", to: "/categories" },
      { label: "The Journey", hash: "parcours" },
      { label: "Key Dates", hash: "dates" },
      { label: "Jury", hash: "jury" },
      { label: "Criteria", hash: "criteres" },
      { label: "Finalists", to: "/finalistes" },
      { label: "Winners", to: "/gagnants" },
    ],
    cta: { label: "Apply", to: "/candidater" },
    tabs: [
      { label: "Home", to: "/", icon: "Home" },
      { label: "Categories", to: "/categories", icon: "LayoutGrid" },
      { label: "Dates", hash: "dates", icon: "CalendarDays" },
      { label: "Jury", hash: "jury", icon: "Users" },
      { label: "Apply", to: "/candidater", icon: "Award" },
    ],
    menuTitle: "Menu",
    menuOpen: "Open menu",
    menuClose: "Close menu",
    skip: "Skip to content",
  },

  ui: {
    discover: "Discover",
    contactTeam: "Contact the team",
    beNotified: "Be notified",
    apply: "Apply",
    edition: "2027 EDITION",
    seeAll: "See all categories",
    seeFinalists: "See the Finalists page",
    seeWinners: "See the Winners page",
    nextDate: "Next date",
    scrollHint: "Scroll",
    prev: "Previous",
    next: "Next",
    soon: "Soon",
    index: "Contents",
    countdown: {
      label: "Applications open in",
      days: "Days",
      hours: "Hours",
      minutes: "Minutes",
      seconds: "Seconds",
      open: "Applications are open.",
    },
    emptyProduct: { name: "Product name", brand: "Brand", category: "Category" },
    footer: { rights: "COSMETICA BEAUTY AWARDS 2027", credit: "Website by", agency: "SOURATI DIGITAL", agencyUrl: "https://sourati.digital/" },
  },

  hero: {
    brand: "COSMETICA BEAUTY AWARDS",
    lines: ["COSMETICA", "BEAUTY AWARDS"],
    tagline: "CELEBRATING BEAUTY EXCELLENCE",
    edition: "2027 EDITION",
    status: "Applications will open soon.",
    text: "A distinction dedicated to the products, brands and expertise that help shape the beauty of tomorrow.",
    imageAlt: "Glass perfume bottle resting on dark fabric, softly lit",
  },

  marquee: ["CELEBRATING BEAUTY EXCELLENCE", "COSMETICA BEAUTY AWARDS", "2027 EDITION"],

  essence: {
    id: "essence",
    eyebrow: "The Awards",
    title: "THE ESSENCE OF THE AWARDS",
    paragraphs: [
      "The COSMETICA BEAUTY AWARDS celebrate the products and brands that stand out for their quality, creativity, innovation and ability to respond to the evolving beauty market.",
      "Through a selection of categories covering the main worlds of beauty, the Awards offer brands a platform to showcase their products, highlight their expertise and benefit from the insight of industry professionals.",
      "Designed at the heart of the COSMETICA AFRICA ecosystem, the Awards bring together brands, manufacturers, experts, distributors, buyers and professionals around a shared ambition: to bring forward the products that deserve to be discovered, recognized and celebrated.",
    ],
    imageAlt: "Skincare bottles lined up on a shelf, soft light",
  },

  why: {
    id: "pourquoi",
    eyebrow: "Why take part",
    title: "WHY TAKE PART?",
    intro:
      "Entering the COSMETICA BEAUTY AWARDS means giving your product the opportunity to stand out, to meet fresh eyes and to have the work behind its creation recognized.",
    items: [
      { title: "PROFESSIONAL EVALUATION", text: "Your product is presented to a jury made up of professionals with complementary expertise, drawn from the different trades of the beauty industry." },
      { title: "INCREASED VISIBILITY", text: "Finalists and winners are showcased on the COSMETICA BEAUTY AWARDS website and on COSMETICA AFRICA's social media, through dedicated content about the selection and the winners." },
      { title: "DISCOVERY BY THE BEAUTY ECOSYSTEM", text: "Your product joins a professional environment bringing together brands, manufacturers, distributors, buyers and industry experts, within the COSMETICA ecosystem." },
      { title: "PRESENCE IN THE AWARDS GALLERY", text: "Finalist products join the official selection of the COSMETICA BEAUTY AWARDS and will be presented in a dedicated space during the four days of COSMEORAN 2027, then of COSMETICA AFRICA 2028. This gives winning products a physical presence with visitors at both events." },
      { title: "AN OFFICIAL DISTINCTION", text: "Finalists and winners receive official communication assets to showcase their distinction." },
      { title: "RECOGNITION THAT GOES FURTHER", text: "A selection or a win can enrich your communication, your product storytelling, your press relations and your exchanges with partners, distributors and buyers." },
    ],
  },

  who: {
    id: "participer",
    eyebrow: "Eligibility",
    title: "WHO CAN ENTER?",
    intro: "The COSMETICA BEAUTY AWARDS are open to beauty players who wish to have their products and expertise recognized.",
    listTitle: "THOSE ELIGIBLE TO ENTER INCLUDE",
    list: [
      "Beauty brands",
      "Cosmetic manufacturers and laboratories",
      "Skincare brands",
      "Haircare brands",
      "Makeup brands",
      "Fragrance brands",
      "Body care brands",
      "Hygiene and personal care brands",
      "Professional beauty brands",
      "Emerging brands",
      "Established brands",
      "Local and international companies",
    ],
    note: "Eligibility conditions may vary by category.",
    faq: [
      {
        q: "Can a brand take part without exhibiting at COSMETICA AFRICA?",
        a: "Yes, subject to the official conditions of participation. The COSMETICA BEAUTY AWARDS are designed to bring together a wide range of industry players and to showcase products from different markets.",
      },
    ],
    nb: "NB: The final eligibility criteria, launch periods and conditions of participation are set out in the official rules of the Awards.",
  },

  categories: {
    id: "categories",
    eyebrow: "2027 Edition",
    title: "THE 2027 CATEGORIES",
    pageIntro: "15 categories",
    items: [
      { n: "01", title: "BEST SKINCARE PRODUCT", text: "A skincare product that stands out for its formulation, performance, user experience and response to the skin's current needs." },
      { n: "02", title: "BEST HAIRCARE PRODUCT", text: "A care, treatment or styling product providing an effective and suitable response to the needs of the hair and scalp." },
      { n: "03", title: "BEST MAKEUP PRODUCT", text: "A makeup product remarkable for its quality, finish, wear, formulation and user experience." },
      { n: "04", title: "BEST FRAGRANCE", text: "A fragrance carried by a distinctive olfactory identity, a quality composition and a coherent universe." },
      { n: "05", title: "BEST BODY CARE PRODUCT", text: "A product dedicated to body care and well-being, combining effectiveness, formulation quality and sensory experience." },
      { n: "06", title: "BEST PERSONAL CARE PRODUCT", text: "A personal care or hygiene product that relevantly meets consumer uses and expectations." },
      { n: "07", title: "BEST MEN'S GROOMING PRODUCT", text: "A product dedicated to men's care and the grooming of the face, body or beard, combining effectiveness, quality and everyday practicality." },
      { n: "08", title: "BEST PROFESSIONAL BEAUTY PRODUCT", text: "A product designed for beauty professionals, meeting their specific needs and the demands of their practice." },
      { n: "09", title: "BEST NATURAL & BOTANICAL PRODUCT", text: "A product based on the use of natural or botanical ingredients, with a coherent formulation and a clearly defined approach." },
      { n: "10", title: "BEAUTY INNOVATION AWARD", text: "An innovation bringing a new approach, technology or application, responding in an original way to a need in the sector." },
      { n: "11", title: "BEST PACKAGING DESIGN", text: "Packaging combining aesthetics, functionality, creativity and consistency with the product's identity." },
      { n: "12", title: "BEST SUSTAINABLE BEAUTY PRODUCT", text: "A product integrating a responsible approach through its formulation, materials, packaging, design or life cycle." },
      { n: "13", title: "BEST NEW PRODUCT LAUNCH", text: "A recent launch carried by a distinctive concept, a clear positioning and a proposition suited to the market." },
      { n: "14", title: "MADE IN ALGERIA BEAUTY AWARD", text: "A product designed and developed in Algeria, reflecting the quality, creativity and expertise of the Algerian beauty industry." },
    ],
    grandPrix: {
      n: "15",
      label: "GRAND PRIX",
      title: "COSMETICA BEAUTY PRODUCT OF THE YEAR",
      text: "The flagship title of the edition, the COSMETICA BEAUTY AWARDS Grand Prix, is awarded to the product demonstrating the most remarkable overall excellence through its quality, concept, execution and relevance.",
      imageAlt: "Perfume bottle on light fabric, golden light",
    },
    nb: "NB: Categories, titles, eligibility criteria and any category changes will be set out in the official rules of the 2027 edition.",
  },

  journey: {
    id: "parcours",
    eyebrow: "The journey",
    title: "THE ROAD TO THE COSMETICA BEAUTY AWARDS",
    steps: [
      { n: "01", title: "APPLY", text: "Select your category and complete your entry file with the requested information." },
      { n: "02", title: "ELIGIBILITY CHECK", text: "Each application is checked against the conditions applicable to the chosen category." },
      { n: "03", title: "PRODUCT SUBMISSION", text: "Eligible candidates send the samples and required materials for evaluation." },
      { n: "04", title: "EVALUATION", text: "Products are assessed according to the criteria defined for their category by the members of the jury." },
      { n: "05", title: "FINALISTS", text: "Products selected for the final are officially announced and highlighted across the Awards platforms." },
      { n: "06", title: "FINAL EVALUATION", text: "Finalists undergo the final evaluation according to the methodology applicable to their category." },
      { n: "07", title: "CEREMONY", text: "The winners are unveiled at the official COSMETICA BEAUTY AWARDS 2027 ceremony." },
    ],
  },

  dates: {
    id: "dates",
    eyebrow: "Calendar",
    title: "KEY DATES",
    // `end` (ISO) is only used to automatically detect the next upcoming date.
    items: [
      { date: "30 OCTOBER 2026", end: "2026-10-30", title: "ANNOUNCEMENT OF THE AWARDS", text: "Official presentation of the 2027 edition and opening of communication." },
      { date: "10 NOVEMBER 2026", end: "2026-11-10", title: "APPLICATIONS OPEN", text: "Brands can start submitting their products." },
      { date: "15 JANUARY 2027", end: "2027-01-15", title: "APPLICATION DEADLINE", text: "Final deadline to submit an application." },
      { date: "31 JANUARY 2027", end: "2027-01-31", title: "SAMPLE DELIVERY DEADLINE", text: "Required products must have been sent within the indicated deadlines." },
      { date: "FEBRUARY – EARLY MARCH 2027", end: "2027-03-10", title: "FIRST EVALUATION PHASE", text: "Jury members assess the applications according to the defined criteria." },
      { date: "15 MARCH 2027", end: "2027-03-15", title: "FINALISTS ANNOUNCEMENT", text: "Selected products advance to the final." },
      { date: "MARCH – EARLY APRIL 2027", end: "2027-04-10", title: "FINAL EVALUATION", text: "The final step before the winners are selected." },
      { date: "LATE APRIL 2027", end: "2027-04-30", title: "AWARDS CEREMONY", text: "Unveiling of the winners and celebration of beauty excellence." },
    ],
    nb: "NB: Dates to be confirmed in the official calendar of the 2027 edition.",
  },

  jury: {
    id: "jury",
    eyebrow: "The jury",
    title: "THE JURY",
    intro: [
      "The credibility of an Award rests on the quality of the experts who evaluate the products.",
      "The COSMETICA BEAUTY AWARDS will bring together a multidisciplinary jury of professionals from different worlds of beauty and complementary disciplines.",
    ],
    profilesTitle: "Depending on the categories, the jury may include profiles from, among others:",
    profiles: [
      "Formulation and research",
      "Product development",
      "Cosmetics and perfumery",
      "Professional beauty",
      "Retail and distribution",
      "Marketing and branding",
      "Packaging and design",
      "Innovation and technologies",
      "Beauty media and expertise",
    ],
    outro: "This diversity of perspectives makes it possible to assess products from several angles and to take into account both their intrinsic qualities and their relevance within their market environment.",
    banner: "Jury composition to be announced soon",
    portraitSlots: 8,
    members: [], // { name, role, photo } — to be filled in when the jury is announced
    nb: "NB: The final composition of the jury will be officially announced through the COSMETICA BEAUTY AWARDS communication channels.",
  },

  criteria: {
    id: "criteres",
    eyebrow: "Evaluation",
    title: "EVALUATION CRITERIA",
    intro: "Each category has its own specificities. The evaluation may notably take into account several dimensions of the product.",
    items: [
      { icon: "Gauge", title: "EFFICACY AND PERFORMANCE", text: "Quality and relevance of the product's performance with regard to its category." },
      { icon: "Sparkles", title: "INNOVATION AND ORIGINALITY", text: "Originality of the concept, approach, formulation, technology or application." },
      { icon: "FlaskConical", title: "FORMULATION AND TECHNOLOGY", text: "Quality and mastery of the formulation, relevance of the ingredients, and performance of the technologies and delivery systems associated with the product." },
      { icon: "Hand", title: "USER EXPERIENCE", text: "Texture, sensoriality, ease of use, practicality and overall experience according to the nature of the product." },
      { icon: "Package", title: "PACKAGING AND DESIGN", text: "Functionality, ergonomics, visual identity, aesthetic consistency and quality of execution." },
      { icon: "BookOpen", title: "CONCEPT AND STORYTELLING", text: "Clarity of positioning, consistency of identity and ability to build a distinctive, coherent narrative." },
      { icon: "Target", title: "MARKET RELEVANCE", text: "Fit with consumer expectations, usage and sector developments." },
      { icon: "Leaf", title: "RESPONSIBILITY", text: "Consideration of environmental, ethical or responsible dimensions where relevant to the category." },
    ],
    nb: "NB: Criteria and their weighting may vary by category and will be detailed in the official rules and methodology.",
  },

  finalists: {
    id: "finalistes",
    eyebrow: "The selection",
    title: "BEING A FINALIST IS ALREADY BEING RECOGNIZED",
    status: "Announcement scheduled for 15 March 2027",
    intro: "Reaching the final of the COSMETICA BEAUTY AWARDS means your product has been retained among the applications evaluated in its category.",
    listTitle: "WHAT FINALISTS MAY RECEIVE",
    items: [
      { title: "OFFICIAL FINALIST STATUS", text: "Official recognition of your selection for the 2027 edition." },
      { title: "FINALIST VISUALS", text: "Dedicated graphic assets to communicate around your selection." },
      { title: "DIGITAL VISIBILITY", text: "Showcasing on the COSMETICA BEAUTY AWARDS communication platforms." },
      { title: "PRESENCE ON THE OFFICIAL SITE", text: "Presentation of the product in the official finalists' selection." },
      { title: "AWARDS GALLERY", text: "Inclusion of the product in the official Awards gallery." },
      { title: "PRESENCE AT THE CEREMONY", text: "Invitation to the official COSMETICA BEAUTY AWARDS ceremony, according to the terms defined by the organization." },
    ],
    products: [], // { image, name, brand, category } — grid ready to receive products
    imageAlt: "Skincare bottles on a dark surface, studio lighting",
  },

  winners: {
    id: "gagnants",
    eyebrow: "The winners",
    title: "THE WINNERS",
    status: "Unveiled in late April 2027",
    intro: "Winning a COSMETICA BEAUTY AWARD gives a product official recognition within a professional ecosystem dedicated to beauty.",
    listTitle: "WINNERS MAY BENEFIT FROM",
    items: [
      { title: "OFFICIAL TROPHY", text: "A physical distinction celebrating the win." },
      { title: "WINNER CERTIFICATE", text: "Official recognition of the win in the relevant category." },
      { title: "WINNER MARK", text: "A mark of distinction intended for the winner's communication, subject to the official rules of use." },
      { title: "DIGITAL COMMUNICATION", text: "Announcement and showcasing of the winners on the Awards platforms." },
      { title: "PRESENCE ON THE OFFICIAL SITE", text: "Presentation of the winning product in the official winners' selection." },
      { title: "EDITORIAL CONTENT", text: "Opportunities for showcasing through content dedicated to the winners." },
      { title: "AWARDS PHOTOGRAPHY AND CONTENT", text: "Showcasing of the product and its distinction in official content, according to the planned arrangements." },
      { title: "VISIBILITY WITHIN THE COSMETICA ECOSYSTEM", text: "Recognition that can be leveraged in the brand's communications with its partners, distributors, buyers and professionals." },
    ],
    products: [],
    nb: "NB: Use of the Winner Mark on products, packaging and commercial materials is subject to the official conditions and rules of use of the COSMETICA BEAUTY AWARDS and to applicable regulations.",
  },

  ecosystem: {
    id: "ecosysteme",
    eyebrow: "Ecosystem",
    title: "AT THE HEART OF THE COSMETICA ECOSYSTEM",
    intro: "The COSMETICA BEAUTY AWARDS are part of a professional ecosystem dedicated to the development of the beauty industry in Africa.",
    items: [
      { icon: "Landmark", title: "COSMETICA AFRICA", text: "A professional gathering bringing together brands, manufacturers, suppliers, distributors, buyers and beauty professionals." },
      { icon: "Handshake", title: "COSMETICA CONNECT", text: "A program dedicated to B2B meetings and connecting with qualified decision-makers and buyers." },
      { icon: "ShoppingBag", title: "BUYERS AND CONSUMERS", text: "Professionals looking for products, brands and new business opportunities." },
      { icon: "Truck", title: "DISTRIBUTORS", text: "Players looking for new brands and products to bring to their markets." },
      { icon: "Users", title: "INDUSTRY PROFESSIONALS", text: "Experts and professionals from different segments of the beauty industry." },
    ],
    outro: "The COSMETICA BEAUTY AWARDS thus extend the vocation of COSMETICA AFRICA: creating connections between products, professionals and markets.",
  },

  finalCall: {
    id: "contact",
    title: "COSMETICA BEAUTY AWARDS 2027",
    tagline: "CELEBRATING BEAUTY EXCELLENCE",
    keyDatesTitle: "KEY DATES",
    keyDates: [
      { label: "Applications open", value: "10 November 2026" },
      { label: "Application deadline", value: "15 January 2027" },
    ],
    applyOn: "Apply on",
    teamTitle: "Awards Team",
    // Editable contact details: leave empty ("") to hide the line.
    team: { email: "", phone: "", other: "" },
    teamLabels: { email: "Email", phone: "Phone", other: "Other" },
    teamPending: "Contact details to be provided",
  },

  contactPage: {
    eyebrow: "Contact",
    title: "CONTACT THE TEAM",
  },

  applyPage: {
    eyebrow: "2027 EDITION",
    closedTitle: "Applications will open soon",
    closedText: "Applications open: 10 November 2026.",
    openTitle: "Applications are open",
    openText: "Apply on awards.cosmeticaafrica.com",
    openButton: "Apply now",
  },

  forms: {
    notify: {
      title: "Be notified of the opening",
      email: "Email address",
      brand: "Brand name (optional)",
      submit: "Notify me",
      sending: "Sending…",
      success: "Thank you. Your address has been registered: you will be notified when applications open.",
    },
    contact: {
      title: "Contact the team",
      name: "Name",
      email: "Email address",
      phone: "Phone",
      brand: "Brand",
      message: "Message",
      submit: "Send",
      sending: "Sending…",
      success: "Thank you. Your message has been sent. The team will get back to you shortly.",
    },
    errors: {
      required: "This field is required.",
      email: "Invalid email address.",
      server: "An error occurred. Please try again.",
    },
  },

  pages: {
    categories: { eyebrow: "2027 Edition", title: "THE 2027 CATEGORIES" },
    finalists: { eyebrow: "Official selection", title: "FINALISTS" },
    winners: { eyebrow: "2027 Edition", title: "WINNERS" },
  },

  notFound: { title: "Page not found", back: "Back to home" },
};

export default content;
